<script lang="ts">
    import type {Rec} from 'src/typings';
    import {asDocument, isDocument} from 'shared/utils/types-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpCover from '../../../../../../features/record/kp-cover/KpCover.svelte';
    import KpCustomParagraph from './KpCustomParagraph.svelte';
    import Labels from 'shared/components/kp-label/Labels.svelte';

    export let value: Rec;
    export let isSelected = false;
</script>

<div class="selectable-record-card">
    <div class="panel panel-default" class:panel-primary={isSelected}>
        <div class="panel-body">
            <div class="card-content">

                {#if !value.external}
                    <div class="record-cover">
                        <!-- target null to disable click on cover -->
                        <KpCover record={value} target={null} fillTo={'width'}/>
                    </div>
                {/if}

                <div class="record-info">
                    <div class="card-labels">
                        {#if value.external}
                            <div class="fond-label">
                                <span class="label label-info">{pipe(value.fond, loc())}</span>
                            </div>
                        {/if}
                        {#if !value.valid}
                            <div>
                                <span class="label label-danger">Nevalidní</span>
                            </div>
                        {/if}
                    </div>

                    <div>
                        <div class="record-name">
                            {#if value.external}
                                <span>{value.name ?? ''}</span>
                            {:else}
                                <a href="/#!/records/{value.id}" target="_blank" rel="noreferrer">{value.name}</a>
                            {/if}
                        </div>

                        <!-- alternative names -->
                        {#if Array.isArray(value.alternativeNames)}
                            <div>
                                {#each value.alternativeNames as alternativeName}
                                    <div style="margin-left: 15px;">
                                        {alternativeName}
                                    </div>
                                {/each}
                            </div>
                        {/if}

                        {#if isDocument(value)}
                            {@const document = asDocument(value)}
                            {#if document.subtitle && document.subtitle.length > 0}
                                <div class="record-subtitle">
                                    <Labels labeleds={document.subtitle} linkifyUrls={false} />
                                </div>
                            {/if}

                            {#if document.primaryAuthors && document.primaryAuthors.length > 0}
                                <div class="list-item-document-autor">
                                    <Labels labeleds={document.primaryAuthors} />
                                </div>
                            {/if}
                        {/if}

                        {#if value?.exports?.portaroSearchItemParagraph}
                            <KpCustomParagraph content={value.exports.portaroSearchItemParagraph} customClass="list-item-document-paragraph-template"/>
                        {/if}
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<style lang="less">
    .selectable-record-card {
        text-align: left;

        .panel {
            margin-bottom: 10px;

            .panel-body {
                padding-top: 7px;
                padding-bottom: 7px;
            }
        }

        .card-content {
            display: flex;

            .record-cover {
                margin-right: 16px;
                width: 70px;
                flex-shrink: 0;
            }

            .record-info {
                width: 100%;
                white-space: normal;
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
            }

            .record-subtitle {
                display: block;
            }

            .card-labels {
                display: flex;
            }
        }
    }
</style>